module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.26320",
      "conversations-internal-schema": "static-1.12666",
      "head-dlb": "static-1.4921",
      "hs-test-utils": "static-1.7908",
      "hubspot-url-utils": "static-1.4047",
      "HubStyleTokens": "static-2.11349",
      "I18n": "static-7.1602",
      "jasmine-runner": "static-1.6366",
      "quartz": "static-1.6864",
      "react": "static-7.184",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.485",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6033",
      "enviro": "static-4.425",
      "hs-promise-rejection-tracking": "static-1.5473",
      "PortalIdParser": "static-2.386",
      "raven": "static-3.5808",
      "raven-hubspot": "static-1.6115",
      "bend-plugin-trellis-migration": "static-1.3322",
      "moment": "static-3.26",
      "customer-data-email": "static-1.17853",
      "cv-backend-services": "static-1.1537",
      "hub-http": "static-1.6116",
      "immutable": "static-2.77",
      "immutable-less": "static-1.4550",
      "quartz-config": "static-1.642",
      "quartz-core": "static-1.6083",
      "transmute": "static-2.85",
      "HeadJS": "static-2.735",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7717",
      "framer-motion": "static-1.70",
      "hs-test-utils-bend-plugin": "static-1.3019",
      "msw": "static-1.39",
      "react-redux": "static-7.70",
      "redux": "static-4.16",
      "testing-library": "static-1.150",
      "foundations-theming": "static-1.4310",
      "i18n-data": "static-1.219",
      "metrics-js": "static-1.9540",
      "moment-timezone": "static-5.81",
      "react-utils": "static-2.5264",
      "jasmine": "static-4.4221",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.64",
      "styled-components": "static-2.88",
      "UIComponents": "static-3.8296",
      "visitor-ui-component-library-icons": "static-1.5844",
      "bender-build-tools": "static-1.3063",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4548",
      "apollo-stack-hubspot": "static-3.84",
      "classnames": "static-2.10",
      "cssUtils": "static-1.768",
      "customer-data-objects": "static-1.7553",
      "customer-data-ui-utilities": "static-1.9722",
      "data-fetching-client": "static-1.9572",
      "FileManagerCore": "static-1.38788",
      "FileManagerLib": "static-1.38929",
      "foundations-assets": "static-1.4744",
      "graphql": "static-1.80",
      "hs-promise-utils": "static-1.5491",
      "hubspot-apollo-client": "static-1.4775",
      "icons": "static-2.639",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.97",
      "rpc-client-utils": "static-1.4541",
      "salesImages": "static-1.523",
      "timezone-utils": "static-2.5141",
      "ui-gdpr-components": "static-1.10245",
      "ts-schema": "static-1.3994",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.134",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.819",
      "hubspotter-http": "static-1.4568",
      "mobile-manifest-mixins": "static-1.508",
      "module-federation": "static-1.21",
      "quartz-auth": "static-1.539",
      "quartz-head": "static-1.529",
      "quartz-i18n": "static-1.539",
      "quartz-routing": "static-1.294",
      "quartz-test": "static-1.539",
      "quartz-tracking": "static-1.243",
      "quick-fetch": "static-1.3832",
      "react-rhumb": "static-1.16552",
      "ui-fonts": "static-1.611",
      "usage-tracker-container": "static-1.7223",
      "usage-tracker-core": "static-1.7083",
      "bend-plugin-foundations-components": "static-1.3986",
      "floating-ui": "static-1.54",
      "foundations-theming-specialty": "static-1.2026",
      "hs-story-utils": "static-1.9327",
      "tanstack-table": "static-1.53",
      "trellis-assets": "static-1.1523",
      "ui-images": "static-2.1128",
      "bend-plugin-foundations-theming": "static-1.2793",
      "foundations-theming-base": "static-1.3295",
      "stylex": "static-1.30",
      "HubStyle": "static-2.11657",
      "sassPrefix": "static-1.154",
      "inbound-db-properties-service-client": "static-1.3762",
      "property-translator": "static-1.5305",
      "react-dnd-compat": "static-1.4515",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.8674",
      "audio-components": "static-1.5760",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29103",
      "file-manager-components": "static-1.23289",
      "FileManagerImages": "static-1.36440",
      "foundations-components-legacy": "static-1.742",
      "immerable": "static-1.4050",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.8831",
      "urlinator": "static-1.4429",
      "video-components": "static-1.12943",
      "video-data-lib": "static-1.34598",
      "video-embed": "static-1.35432",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.234",
      "chirp-fetch": "static-1.1778",
      "hub-http-shared-msw-handlers": "static-1.9725",
      "hubspotter-http-shared-msw-handlers": "static-1.9723",
      "history": "static-4.47",
      "react-router-dom": "static-5.26",
      "usage-tracker-session-replay": "static-1.4919",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.20799",
      "ContentUtils": "static-1.68035",
      "copilot-toolkit": "static-1.10837",
      "sanitize": "static-1.4370",
      "sanitize-text": "static-1.8042",
      "content-assistance-lib": "static-1.7598",
      "usage-tracker": "static-1.7233",
      "ui-addon-iframeable": "static-1.8946",
      "video-components-external": "static-1.10940",
      "unified-auth-core-lib": "static-1.626",
      "content-icons-ui": "static-1.2201",
      "social-insights-client-types": "static-1.21775",
      "SharedI18nStrings": "static-1.181",
      "outpost": "static-1.4092",
      "amplitude-session-replay-browser": "static-1.58",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4706",
      "integrations-lib": "static-1.15776",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5490",
      "magpie-types": "static-1.4950",
      "simple-logging-lib": "static-1.2948",
      "superstore": "static-1.4666",
      "ui-addon-video-player": "static-1.8593",
      "ui-coaching-tips": "static-1.28249",
      "navigation-messaging": "static-1.6971",
      "content-media-composition-data-lib": "static-1.11894",
      "content-media-compositions": "static-2.15901",
      "idb-keyval": "static-1.42",
      "media-bridge-lib": "static-1.18743",
      "fsm": "static-1.3630",
      "flux-actions": "static-1.325",
      "frontend-preferences-client": "static-1.7821",
      "integrations-error-boundary-lib": "static-1.13191",
      "integrations-tracking-lib": "static-1.5492",
      "laboratory-lib": "static-3.7056",
      "native-integrations-shared-strings": "static-1.7683",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10271",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11044",
      "ui-shepherd-react": "static-3.10044",
      "unified-auth": "static-1.345",
      "reactive-lib": "static-1.621",
      "growth-onboarding-feedback-components": "static-1.6479",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.2903",
      "foundations-components-test-utils": "static-1.5200",
      "react-dlb": "static-1.76",
      "crm-record-cards-service-types": "static-1.3526",
      "framework-data-schema-resolvers": "static-1.6772",
      "location-customization-utils-lib": "static-1.8912",
      "batch-promise": "static-1.1449",
      "conditional-properties-service-client": "static-1.3713",
      "crm-pipelines-api-client-types": "static-1.4058",
      "framework-builder-read-service-client": "static-1.3924",
      "framework-data-schema-quick-fetch": "static-1.6677",
      "inbound-db-meta-service-client": "static-1.3505",
      "multi-currency-client-types": "static-1.3606",
      "persist-promise": "static-1.3606"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.26320",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12666",
      "head-dlb": "/head-dlb/static-1.4921",
      "hs-test-utils": "/hs-test-utils/static-1.7908",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4047",
      "HubStyleTokens": "/HubStyleTokens/static-2.11349",
      "I18n": "/I18n/static-7.1602",
      "jasmine-runner": "/jasmine-runner/static-1.6366",
      "quartz": "/quartz/static-1.6864",
      "react": "/react/static-7.184",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.485",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6033",
      "enviro": "/enviro/static-4.425",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
      "PortalIdParser": "/PortalIdParser/static-2.386",
      "raven": "/raven/static-3.5808",
      "raven-hubspot": "/raven-hubspot/static-1.6115",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3322",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.17853",
      "cv-backend-services": "/cv-backend-services/static-1.1537",
      "hub-http": "/hub-http/static-1.6116",
      "immutable": "/immutable/static-2.77",
      "immutable-less": "/immutable-less/static-1.4550",
      "quartz-config": "/quartz-config/static-1.642",
      "quartz-core": "/quartz-core/static-1.6083",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.735",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7717",
      "framer-motion": "/framer-motion/static-1.70",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3019",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.70",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.150",
      "foundations-theming": "/foundations-theming/static-1.4310",
      "i18n-data": "/i18n-data/static-1.219",
      "metrics-js": "/metrics-js/static-1.9540",
      "moment-timezone": "/moment-timezone/static-5.81",
      "react-utils": "/react-utils/static-2.5264",
      "jasmine": "/jasmine/static-4.4221",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.64",
      "styled-components": "/styled-components/static-2.88",
      "UIComponents": "/UIComponents/static-3.8296",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5844",
      "bender-build-tools": "/bender-build-tools/static-1.3063",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4548",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.768",
      "customer-data-objects": "/customer-data-objects/static-1.7553",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9722",
      "data-fetching-client": "/data-fetching-client/static-1.9572",
      "FileManagerCore": "/FileManagerCore/static-1.38788",
      "FileManagerLib": "/FileManagerLib/static-1.38929",
      "foundations-assets": "/foundations-assets/static-1.4744",
      "graphql": "/graphql/static-1.80",
      "hs-promise-utils": "/hs-promise-utils/static-1.5491",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4775",
      "icons": "/icons/static-2.639",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.97",
      "rpc-client-utils": "/rpc-client-utils/static-1.4541",
      "salesImages": "/salesImages/static-1.523",
      "timezone-utils": "/timezone-utils/static-2.5141",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10245",
      "ts-schema": "/ts-schema/static-1.3994",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.134",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.819",
      "hubspotter-http": "/hubspotter-http/static-1.4568",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.508",
      "module-federation": "/module-federation/static-1.21",
      "quartz-auth": "/quartz-auth/static-1.539",
      "quartz-head": "/quartz-head/static-1.529",
      "quartz-i18n": "/quartz-i18n/static-1.539",
      "quartz-routing": "/quartz-routing/static-1.294",
      "quartz-test": "/quartz-test/static-1.539",
      "quartz-tracking": "/quartz-tracking/static-1.243",
      "quick-fetch": "/quick-fetch/static-1.3832",
      "react-rhumb": "/react-rhumb/static-1.16552",
      "ui-fonts": "/ui-fonts/static-1.611",
      "usage-tracker-container": "/usage-tracker-container/static-1.7223",
      "usage-tracker-core": "/usage-tracker-core/static-1.7083",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3986",
      "floating-ui": "/floating-ui/static-1.54",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2026",
      "hs-story-utils": "/hs-story-utils/static-1.9327",
      "tanstack-table": "/tanstack-table/static-1.53",
      "trellis-assets": "/trellis-assets/static-1.1523",
      "ui-images": "/ui-images/static-2.1128",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2793",
      "foundations-theming-base": "/foundations-theming-base/static-1.3295",
      "stylex": "/stylex/static-1.30",
      "HubStyle": "/HubStyle/static-2.11657",
      "sassPrefix": "/sassPrefix/static-1.154",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3762",
      "property-translator": "/property-translator/static-1.5305",
      "react-dnd-compat": "/react-dnd-compat/static-1.4515",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8674",
      "audio-components": "/audio-components/static-1.5760",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29103",
      "file-manager-components": "/file-manager-components/static-1.23289",
      "FileManagerImages": "/FileManagerImages/static-1.36440",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.742",
      "immerable": "/immerable/static-1.4050",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.8831",
      "urlinator": "/urlinator/static-1.4429",
      "video-components": "/video-components/static-1.12943",
      "video-data-lib": "/video-data-lib/static-1.34598",
      "video-embed": "/video-embed/static-1.35432",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.234",
      "chirp-fetch": "/chirp-fetch/static-1.1778",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9725",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9723",
      "history": "/history/static-4.47",
      "react-router-dom": "/react-router-dom/static-5.26",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4919",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.20799",
      "ContentUtils": "/ContentUtils/static-1.68035",
      "copilot-toolkit": "/copilot-toolkit/static-1.10837",
      "sanitize": "/sanitize/static-1.4370",
      "sanitize-text": "/sanitize-text/static-1.8042",
      "content-assistance-lib": "/content-assistance-lib/static-1.7598",
      "usage-tracker": "/usage-tracker/static-1.7233",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8946",
      "video-components-external": "/video-components-external/static-1.10940",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.626",
      "content-icons-ui": "/content-icons-ui/static-1.2201",
      "social-insights-client-types": "/social-insights-client-types/static-1.21775",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
      "outpost": "/outpost/static-1.4092",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4706",
      "integrations-lib": "/integrations-lib/static-1.15776",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5490",
      "magpie-types": "/magpie-types/static-1.4950",
      "simple-logging-lib": "/simple-logging-lib/static-1.2948",
      "superstore": "/superstore/static-1.4666",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8593",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28249",
      "navigation-messaging": "/navigation-messaging/static-1.6971",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11894",
      "content-media-compositions": "/content-media-compositions/static-2.15901",
      "idb-keyval": "/idb-keyval/static-1.42",
      "media-bridge-lib": "/media-bridge-lib/static-1.18743",
      "fsm": "/fsm/static-1.3630",
      "flux-actions": "/flux-actions/static-1.325",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7821",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13191",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5492",
      "laboratory-lib": "/laboratory-lib/static-3.7056",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7683",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10271",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11044",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10044",
      "unified-auth": "/unified-auth/static-1.345",
      "reactive-lib": "/reactive-lib/static-1.621",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6479",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2903",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5200",
      "react-dlb": "/react-dlb/static-1.76",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3526",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6772",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8912",
      "batch-promise": "/batch-promise/static-1.1449",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3713",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4058",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3924",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6677",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3505",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3606",
      "persist-promise": "/persist-promise/static-1.3606"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.26320",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};